var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dev-warning-banner",staticStyle:{"position":"sticky","top":"0","z-index":"9999","width":"100%","height":"48px"}},[_vm._v("\n    Ambiente de desarrollo no productivo\n")])}
var staticRenderFns = []

export { render, staticRenderFns }